/* TALISHKO — minimum order kuralının TEK kaynağı.
   Hem mini-cart drawer'ı (tlsk-cart-rewards.js) hem /cart sayfası (tlsk-cart-page.js)
   bunu çağırır. Kural iki dosyada ayrı yazılırsa zamanla birbirinden sapar.

   Config global tema ayarlarından gelir (window.TLSK_MIN_ORDER_CFG). Section
   ayarı kullanılamazdı: mini_cart section'ı /cart sayfasında render EDİLMİYOR,
   dolayısıyla oradaki ayarlar cart sayfasından okunamıyor. */
(function () {
  if (window.TLSK_MIN_ORDER) return;

  var CFG = window.TLSK_MIN_ORDER_CFG || {};
  var MIN = (CFG.min != null && CFG.min >= 0) ? CFG.min : 5000;   // cents
  var FMT = CFG.moneyFormat || '${{amount}}';

  // Muafiyetin TEK kaynağı: Theme settings > Minimum order (Talishko) > exempt products.
  // Kod tarafında ürün tipi / SKU eşleşmesi bilerek YOK — ekranda görünmeyen ikinci
  // bir kural, listeye bakıp "muafiyet kapalı" diyen herkesi yanıltır.
  var IDS = (CFG.exemptIds || []).map(function (v) { return String(v); });

  function money(c) {
    var v = (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return FMT.split('{{amount}}').join(v).split('{{amount_no_decimals}}').join(Math.round(c / 100));
  }

  function isExempt(item) {
    return IDS.indexOf(String(item.product_id)) !== -1;
  }

  // Eşik yalnızca muaf OLMAYAN satırlardan hesaplanır. Sepette sadece muaf ürün
  // varsa kapı hiç devreye girmez, yoksa $0 ürün eşiği asla dolduramaz.
  function evaluate(cart) {
    var payable = (cart.items || []).filter(function (i) { return !isExempt(i); });
    var sub = payable.reduce(function (n, i) { return n + (i.final_line_price || 0); }, 0);
    return {
      blocked: MIN > 0 && payable.length > 0 && sub < MIN,
      sub: sub,
      needed: Math.max(0, MIN - sub),
      pct: MIN > 0 ? Math.min(100, (sub / MIN) * 100) : 100
    };
  }

  window.TLSK_MIN_ORDER = { min: MIN, isExempt: isExempt, evaluate: evaluate, money: money };
})();
